import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getToken,
  getWarehouses,
  requestErrorHandler,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
const server = EnvSettings.server;

export default function AlterStockDialog({
  open,
  oldData,
  newData,
  onClose,
  submit,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [warehouseLocation, setWarehouseLocation] = useState();
  const [editedData, setEditedData] = useState();
  useEffect(() => {
    getWarehouses(setWarehouseLocation, dispatch);
  }, [dispatch]);

  const checkStockAllocation = (selectedShipment, editedShipment) => {
    // If the dispatching or receiving warehouse is modifiable ask for permission to adjust stock
    var pick = warehouseLocation.find(
      (f) => f.editableStock && editedShipment?.pickupAddress?.includes(f.name)
    ); // true flag if we are shipping from an editable warehouse
    var deli = warehouseLocation.find(
      (f) =>
        f.editableStock &&
        editedShipment?.shippingInfo?.companyName?.includes(f.name)
    ); // true flag if we are delivering to an editable warehouse
    var data = { ...editedShipment };

    if (
      pick &&
      selectedShipment.status === "waiting" &&
      editedShipment.status === "delivered"
    ) {
      // Ask for dispatch
      if (data.stockAlterations) {
        data.stockAlterations = [...data.stockAlterations, "dispatch"];
      } else {
        data.stockAlterations = ["dispatch"];
      }
    }

    if (
      pick &&
      selectedShipment.status === "waiting" &&
      editedShipment.status === "transit"
    ) {
      // Ask for dispatch
      if (data.stockAlterations) {
        data.stockAlterations = [...data.stockAlterations, "dispatch"];
      } else {
        data.stockAlterations = ["dispatch"];
      }
    }
    if (
      deli &&
      selectedShipment.status === "transit" &&
      editedShipment.status === "delivered"
    ) {
      if (data.stockAlterations) {
        data.stockAlterations = [...data.stockAlterations, "resupply"];
      } else {
        data.stockAlterations = ["resupply"];
      }
    }

    if (
      deli &&
      selectedShipment.status === "waiting" &&
      editedShipment.status === "delivered"
    ) {
      // Ask for resupply
      if (data.stockAlterations) {
        data.stockAlterations = [...data.stockAlterations, "resupply"];
      } else {
        data.stockAlterations = ["resupply"];
      }
    }

    return data;
  };

  const addNote = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        note: "Received item count was different from the dispatched amount!",
        ShipmentId: newData.id,
      }),
    };
    return fetch(server + "/add_note", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        return true;
      });
  };

  const addStockQuantity = (data) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        stock_item: data,
        relative_modification: true,
      }),
    };
    return fetch(server + "/add_stock_quantity", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        return true;
      });
  };

  useEffect(() => {
    setEditedData(JSON.parse(JSON.stringify(newData)));
  }, [newData]);

  return warehouseLocation && open ? (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Alter stock?"}</DialogTitle>
      <DialogContent>
        <Grid container style={{ marginBottom: 20 }}>
          <Grid item xs={12}>
            {t("shipments.itemsToBeModified")}
          </Grid>
          {checkStockAllocation(oldData, newData).stockAlterations.map((m) => {
            if (m === "dispatch") {
              return (
                <Grid
                  item
                  container
                  xs={12}
                  style={{ marginTop: 20 }}
                  spacing={1}
                >
                  <Grid item xs={12}>
                    <Typography>
                      {t("shipments.itemsRemovedFrom") +
                        warehouseLocation.find((w) =>
                          editedData.pickupAddress?.includes(w.name)
                        ).label +
                        t("shipments.toStock")}
                    </Typography>
                  </Grid>

                  {(newData.genericDevices || []).map((g) => {
                    if (g.id && !isNaN(g.id) && g.sku) {
                      var obj = (editedData.genericDevices || []).find(
                        (f) => f.sku === g.sku
                      );
                      if (!obj) {
                        return null;
                      }
                      return (
                        <>
                          <Grid item xs={6}>
                            <TextField
                              label={"SKU"}
                              variant="outlined"
                              fullWidth
                              disabled
                              value={obj.sku}
                            ></TextField>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label={t("count")}
                              value={obj.count}
                              variant="outlined"
                              fullWidth
                              type="number"
                              inputProps={{
                                min: 0,
                                max: Number(g.count),
                                style: { textAlign: "right" },
                              }}
                              onChange={(e) => {
                                var arr = editedData.genericDevices.filter(
                                  (f) => f.sku !== g.sku
                                );
                                obj.count = Number(e.target.value);
                                arr.push(obj);
                                setEditedData({
                                  ...editedData,
                                  genericDevices: [...arr],
                                });
                              }}
                            ></TextField>
                          </Grid>
                        </>
                      );
                    }
                    return null;
                  })}
                </Grid>
              );
            }
            if (m === "resupply") {
              return (
                <Grid
                  item
                  container
                  xs={12}
                  style={{ marginTop: 20 }}
                  spacing={1}
                >
                  <Grid item xs={12}>
                    <Typography>
                      {t("shipments.itemsAddedTo") +
                        warehouseLocation.find((w) =>
                          editedData.shippingInfo.companyName.includes(w.name)
                        ).label +
                        t("shipments.toStock")}
                    </Typography>
                  </Grid>
                  {(newData.genericDevices || []).map((g) => {
                    var obj = (editedData.genericDevices || []).find(
                      (f) => f.sku === g.sku
                    );
                    if (!obj) {
                      return null;
                    }
                    if (g.id && !isNaN(g.id) && g.sku) {
                      return (
                        <>
                          <Grid item xs={6}>
                            <TextField
                              label={"SKU"}
                              variant="outlined"
                              fullWidth
                              disabled
                              value={g.sku}
                            ></TextField>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label={t("count")}
                              value={obj.count}
                              variant="outlined"
                              fullWidth
                              type="number"
                              inputProps={{
                                min: 0,
                                max: Number(g.count),
                                style: { textAlign: "right" },
                              }}
                              onChange={(e) => {
                                var arr = editedData.genericDevices.filter(
                                  (f) => f.sku !== g.sku
                                );
                                obj.count = Number(e.target.value);
                                arr.push(obj);
                                setEditedData({
                                  ...editedData,
                                  genericDevices: [...arr],
                                });
                              }}
                            ></TextField>
                          </Grid>
                        </>
                      );
                    }
                    return null;
                  })}
                </Grid>
              );
            }
            return null;
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setEditedData();
            onClose();
          }}
          color="primary"
          variant="outlined"
          autoFocus
        >
          {t("cancel")}
        </Button>
        <Button
          onClick={submit || (() => {})}
          color="secondary"
          variant="contained"
          autoFocus
        >
          {t("shipments.continueWithoutStockModifications")}
        </Button>
        <Button
          onClick={() => {
            if (checkStockAllocation(oldData, newData).stockAlterations) {
              var array = checkStockAllocation(
                oldData,
                newData
              ).stockAlterations;
              var proms = [];
              for (let index = 0; index < array.length; index++) {
                const element = array[index];
                for (
                  let idx = 0;
                  idx < (editedData.genericDevices || []).length;
                  idx++
                ) {
                  const dev = editedData.genericDevices[idx];
                  if (!dev.id || isNaN(dev.id) || !dev.sku) {
                    // Skip items that are not in the Stock
                    continue;
                  }
                  proms.push(
                    new Promise((resolve, reject) => {
                      resolve(
                        addStockQuantity({
                          ...dev,
                          total:
                            element === "dispatch" ? dev.count * -1 : dev.count,
                          free:
                            element === "dispatch" ? dev.count * -1 : dev.count,
                          warehouse:
                            element === "dispatch"
                              ? newData.pickupAddress
                              : newData.shippingInfo.companyName,
                          reason: element,
                        })
                      );
                    })
                  );
                }
              }
              var b = false;
              for (
                let index = 0;
                index < (newData.genericDevices || []).length;
                index++
              ) {
                const element = newData.genericDevices[index];
                if (
                  (editedData.genericDevices || []).find(
                    (f) => f.sku === element.sku
                  )?.count !== element.count
                ) {
                  b = true;
                }
              }
              if (b) {
                proms.push(
                  new Promise((resolve, reject) => {
                    resolve(addNote());
                  })
                );
              }
              Promise.all(proms).then(() => {
                submit();
              });
            }
          }}
          color="primary"
          variant="contained"
        >
          {t("yes")}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
}
